/**
 * useChatConfirmationHandlers — shared onConfirm/onReject handlers for the
 * confirm/reject tool-use flow, used by both the Dashboard assistant rail and
 * the standalone /assistant conversation route.
 */

import type { useChat } from "./useChat";

export function useChatConfirmationHandlers(chat: ReturnType<typeof useChat>) {
  const onConfirm = () => {
    const pending = chat.messages.find((m) => m.confirmation);
    if (pending?.confirmation) {
      void chat.confirmAction(pending.id, pending.confirmation.tool_id, pending.confirmation.tool_name);
    }
  };

  const onReject = () => chat.rejectAction();

  return { onConfirm, onReject };
}
